import { createChecksumAddressRecordOrThrow } from "./utils";
import {
  ChainIdLegacy,
  ChecksumAddress,
  SupportedChainValue,
} from "@silo/types";
import { TOKEN_ADDRESS as TOKEN_ADDRESS_NEW } from "@silo/config";
import { satisfies } from "effect/Function";

export type TokenAddressChainValue = typeof TOKEN_ADDRESS;

/**
 * @deprecated use `TOKEN_ADDRESS` from `@silo/config`
 */
export const TOKEN_ADDRESS = satisfies<
  SupportedChainValue<Record<string, ChecksumAddress>>
>()({
  [ChainIdLegacy.MAINNET]: createChecksumAddressRecordOrThrow(
    TOKEN_ADDRESS_NEW.ethereum
  ),
  [ChainIdLegacy.ARBITRUM]: createChecksumAddressRecordOrThrow(
    TOKEN_ADDRESS_NEW.arbitrum
  ),
  [ChainIdLegacy.OPTIMISM]: createChecksumAddressRecordOrThrow(
    TOKEN_ADDRESS_NEW.optimism
  ),
  [ChainIdLegacy.BASE]: createChecksumAddressRecordOrThrow(
    TOKEN_ADDRESS_NEW.base
  ),
  [ChainIdLegacy.ANVIL]: createChecksumAddressRecordOrThrow(
    TOKEN_ADDRESS_NEW.anvil
  ),
  [ChainIdLegacy.LOCAL]: createChecksumAddressRecordOrThrow(
    TOKEN_ADDRESS_NEW.local
  ),
} as const);

export const MainnetTokenAddress = TOKEN_ADDRESS[ChainIdLegacy.MAINNET];
export const ArbitrumTokenAddress = TOKEN_ADDRESS[ChainIdLegacy.ARBITRUM];
export const OptimismTokenAddress = TOKEN_ADDRESS[ChainIdLegacy.OPTIMISM];
export const BaseTokenAddress = TOKEN_ADDRESS[ChainIdLegacy.BASE];
